import * as yup from 'yup';
import { personalInfoSchema } from './personalInfoSchema';
export const currentUserSchema = yup.object().camelCase().required().shape({
    id: yup.string().required(),
    piid: yup.string().required(),
    email: yup.string().required(),
    firstname: yup.string().required(),
    lastname: yup.string().required(),
});
export const userSchema = yup.object().camelCase().required().shape({
    id: yup.string().required(),
    email: yup.string().required(),
    personalInfo: personalInfoSchema,
    affiliations: yup.array().nullable(),
    tasksDue: yup.string().nullable()
});
